import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    modalHeader: {
        display: "flex",
        alignItems: "center",
        padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
        borderBottom: `1px solid ${theme.palette.border.select}`,
        fontSize: "18px",
        fontWeight: 400,
        fontFamily: "Open Sans",
        color: theme.palette.info.main,
    },
    modalBody: {
        padding: theme.spacing(6),
        display: "flex",
        flexDirection: "column",
    },
    description: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            fontWeight: 400,
            fontSize: "16px",
        },
    },
    footer: {
        borderTop: `1px solid ${theme.palette.border.select}`,
        display: "flex",
        padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
        gap: theme.spacing(4),
        justifyContent: "flex-end",
    },
    submitButton: {
        "&.MuiButton-root": {
            fontFamily: "Open Sans !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
        },
    },
}));

export const modalStyles = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "592px",
    maxHeight: "calc(100vh - 32px)",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: "4px",
};
